import script from "./SDS.vue?vue&type=script&setup=true&lang=js"
export * from "./SDS.vue?vue&type=script&setup=true&lang=js"

import "./SDS.vue?vue&type=style&index=0&id=a59214f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a59214f8"]])

export default __exports__